<template>
  <div class="box">
    <div class="box-title">
      <div class="content-center">
        <img src="@/assets/images/title-logo.png" alt="">
      </div>
    </div>
    <div class="box-nav">
      <div class="content-center box-nav-slide">
        <div
          :class="slideIndex === item.id ? ['active', 'box-nav-text'] : 'box-nav-text'"
          v-for="(item) in navList"
          :key="item.id"
          @click="slideNav(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="box-user">
      <div class="box-user-detail">
        <div class="user-image">
          <img src="@/assets/images/user-logo.png" alt="">
        </div>
        <dir class="user-message">
          {{ userInfo.username }}
        </dir>
        <div class="user-logout" @click="logoutUser">注销</div>
      </div>
      <div class="box-user-record">
        <div class="record-month">
          当月充值金额：<span style="color: #e89330">{{ userInfo.monthAmount }}</span>
        </div>
        <div class="record-total">
          累计充值金额：<span style="color: #e89330">{{ userInfo.totalAmount }}</span>
        </div>
        <div class="record-integral">
          <i class="el-icon-question" @click="showRules"></i> 积分余额：<span style="color: #e89330">{{ userInfo.userPoint }}</span>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showPop">
      <div class="rules-pop">
        <div class="pop-title">
          <div class="pop-tip">积分说明</div>
          <div class="pop-close" @click="closePop">X</div>
        </div>
        <div class="pop-detail">
          <div class="detail-msg">
            <p>
              1.如何获取积分
            </p>
            <span>
              通过网页充值，成功支付之后可获得积分返利。每消费1元可获得100积分。赠送积分数量以订单实际支付的金额为准，积分将在完成订单支付后24小时内到账，于6个月后正常清理。
            </span>
            <p>
              2.积分的用途
            </p>
            <span>
              积分可用于在积分商城中兑换虚拟道具，一经确认消耗的积分不会退还。获得的道具将于24小时内发送至对应账号（角色）。
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <couponModule v-if="slideIndex == 2"/> -->
    <totalModule :slideNav="parNav" :totalData="userInfo"/>
  </div>
</template>
<script>
// import couponModule from '@/components/couponModule/couponModule.vue'
import totalModule from '@/components/TotalModule.vue'
import { getNavMenu } from '@/api/common'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      navList: [
        {
          id: 1,
          name: '用户中心',
          children: [
            { id: 'PointsDetails', name: '积分明细' },
            { id: 'UserInformation', name: '我的资料', }
          ]
        },
        {
          id: 2,
          name: '优惠券',
          prop: 'coupon',
          children: [
            { id: 'DailyBenefits', name: '每日福利' },
            { id: 'Coupons', name: '我的优惠券', },
            { id: 'HistoryCoupons', name: '历史优惠券', },
          ]
        },
        {
          id: 3,
          name: '积分商城',
          prop: 'points_mall',
          children: [
            { id: 'Redeem', name: '积分兑换', },
            { id: 'ExchangeRecord', name: '兑换记录', isIcon: true }
          ]
        },
        {
          id: 4,
          prop: 'recharge_center',
          name: '充值中心',
        },
      ],
      parNav: null,
      slideIndex: 3,
      showPop: false,
      defalutArr: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
  },
  components: {
    // couponModule,
    totalModule,
  },
  created() {
    this.getSlideNav()
    this.parNav = this.navList.filter((item, index) => (index + 1) === this.slideIndex)[0]['children']
  },
  mounted() {
    if (JSON.stringify(this.userInfo) === '{}' ) {
      this.$store.dispatch('getUserInfo')
    }
  },
  methods: {
    slideNav(data) {
      if (data.id === 4) {
        window.open('/pay')
        this.slideIndex = 1
      } else {
        this.slideIndex = data.id
        if (data.children.length !== 0) {
          this.parNav = data.children
        }
      }
    },
    showRules() {
      this.showPop = true
    },
    closePop() {
      this.showPop = false
    },
    logoutUser() {
      this.$store.dispatch('signOut')
    },
    getSlideNav() {
      getNavMenu().then((res) => {
        if (res && res.code === 0) {
          res.data.map((item) => {
            if (this.defalutArr.indexOf(item.abbreviation) === -1) {
              this.defalutArr.push(item.abbreviation)
            }
          })
          this.navList = this.navList.filter((item) => { return this.defalutArr.indexOf(item.prop) !== -1 })
        }
      })
    }
  },
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  box-sizing: border-box;
  .content-center {
    max-width: 1200px;
    margin: 0 auto;
  }
  .box-title {
    background: #fff;
    max-width: 100%;
    padding: 10px 0;
    margin: 0 auto;
  }
  .box-nav {
    width: 100%;
    background: #ed9500;
    .box-nav-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      .box-nav-text {
        line-height: 45px;
        width: 150px;
        text-align: center;
        color: #fff;
        font-size: 18px;
        cursor: pointer;
      }
      .active {
        background: #ec6c04;
      }
    }
  }
  .box-user {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    background: #fff;
    padding: 24px 28px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .box-user-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-right: 1px dashed #cccccc;
    padding-right: 50px;
    .user-image {
      width: 50px;
      height: 50px;
      border-radius: 25px;
      background: #a8aeff;
      img {
        max-width: 100%;
      }
    }
    .user-message {
      font-size: 15px;
      color: #6a6a6a;
      font-weight: 700;
      padding: 0;
      margin-left: 15px;
    }
    .user-logout {
      font-size: 15px;
      font-weight: 700;
      padding: 0;
      color: #F56C6C;
      margin-left: 15px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .box-user-record {
    margin-left: 25px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #606266;
    .record-month, .record-total {
      margin-right: 20px;
    }
    /deep/ .el-icon-question {
      cursor: pointer !important;
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
    .rules-pop {
      position: absolute;
      left: 50%;
      top: 25%;
      transform: translateX(-50%);
      border: 1px solid #c9bdbd;
      width: 625px;
      height: 400px;
      background: #fff;
      padding: 15px 15px;
      box-sizing: border-box;
      animation: showDialog 0.5s;
      animation-timing-function: cubic-bezier(0.6,0,0.4,1);
      .pop-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pop-tip {
          font-size: 24px;
          color: #ec6c04;
        }
        .pop-close {
          color: #c2c2c2;
          font-size: 25px;
          cursor: pointer;
        }
      }
      .pop-detail {
        margin-top: 40px;
        p {
          font-size: 18px;
          color: #646464;
          margin: 0 auto;
          margin-top: 15px;
        }
        span {
          display: block;
          font-size: 15px;
          color: #646464;
          margin-top: 10px;
        }
      }
    }
  }
}
@keyframes showDialog {
  0% {
    opacity: 0;
    left: 50%;
    transform: scale3d(0, 0, 0), translateX(-50%);
  }
  100% {
    opacity: 1;
    left: 50%;
    transform: scale3d(1, 1, 1), translateX(-50%);
  }
}
</style>